export const THREAD_WORKSPACE_SCOPE = {
  CURRENT: 'current',
  ALL: 'all',
}

export const THREAD_WORKSPACE_SCOPE_TABS = [
  { value: THREAD_WORKSPACE_SCOPE.CURRENT, label: 'This workspace' },
  { value: THREAD_WORKSPACE_SCOPE.ALL, label: 'All workspace' },
]
